import Swal from 'sweetalert2';
import { onErrorShowMessage } from '~src/errors';
import getGraphQlClient from '~graphql/getGraphQlClient';
import { RENAME_TEMPLATE } from '~graphql/queries/modifyTemplate';
import { handleTabTemplates } from '../../sidebar/';
import { RENAME_TEMPLATE_DEFAULT } from '../../~graphql/queries/modifyTemplate';

const applyRename = async (id, isGlobal, name) => {
  const graphQlClient = await getGraphQlClient();

  return graphQlClient.mutate({
    variables: { id, name },
    mutation: isGlobal ? RENAME_TEMPLATE_DEFAULT : RENAME_TEMPLATE,
  });
};

const sanitize = (str) => {
  return str.replace(/[^\w. ]/gi, (c) => {
    return '&#' + c.charCodeAt(0) + ';';
  });
};

export const renameTemplate = async (templateId, isGlobal) => {
  const result = await Swal.fire({
    title: 'Inserisci il nome del modello',
    input: 'text',
    showCancelButton: true,
    inputValidator: (value) => {
      if (!value) {
        return 'Il nome che hai inserito non è valido';
      } else if (value.length < 2) {
        return 'Il nome che hai inserito è troppo breve';
      } else if (value.length > 30) {
        return 'Il nome che hai inserito è troppo lungo';
      }
    },
    confirmButtonColor: '#278e8e',
  });

  try {
    if (result.isDismissed) {
      Swal.close();
      return;
    }
    await applyRename(templateId, isGlobal, sanitize(result.value));
    await handleTabTemplates(true);
    Swal.fire({
      title: 'Rinominato!',
      text:
        'Il modello è stato rinominato ed è ora pronto per essere utilizzato.',
      icon: 'success',
      confirmButtonColor: '#278e8e',
    });
  } catch (err) {
    console.error(err);
    onErrorShowMessage();
  }
};
